/**
 * Consume the backend's shared Guesty bookability decision. The status
 * fallback keeps older cached payloads safe during rolling deployments.
 */
export function isListingCalendarRowBookable(row) {
    if (!row || typeof row !== 'object') return false;
    if (typeof row.bookable === 'boolean') return row.bookable;

    return row.status === 'available';
}

/**
 * A range must begin on an occupiable night. Checkout-only boundary dates are
 * selectable after a valid start date, but cannot become check-in dates.
 */
export function isListingCalendarRangeStartBookable(row) {
    return isListingCalendarRowBookable(row) && !row.cta;
}
